<div class="new-calibration-wrapper">
  <h3>Name your robot installation.</h3>
  <p>
    This name helps you easily recognize and manage your robot setup. <br />
    Don’t worry, you can change it later by clicking on the name.
  </p>

  <app-field *ngFor="let field of fields" [field]="field"></app-field>

  <div class="actions">
    <button
      *ngIf="!changeRequired"
      mat-stroked-button
      (click)="dialogRef.close()"
    >
      Cancel
    </button>
    <button
      color="accent"
      mat-raised-button
      (click)="close()"
      [disabled]="!fieldsValid()"
    >
      Confirm
    </button>
  </div>
</div>
